const extractTokens = parseResult =>
  parseResult &&
  parseResult.expression &&
  parseResult.expression.status &&
  parseResult.expression.status.tokens &&
  parseResult.expression.status.tokens.length
    ? parseResult.expression.status.tokens
    : null

const extractParseError = parseResult =>
  parseResult && parseResult.expression && parseResult.expression.status && parseResult.expression.status.errors
    ? parseResult.expression.status.errors.find(error => 'parse' === error.type)
    : null

const extractLastTokenProperty = (tokens, property, offset = 1) => {
  const lastToken = tokens ? tokens[tokens.length - offset] : null
  return lastToken ? lastToken[property] : null
}

const extractBeforeCursor = (textBeforeCursor = '', tokens = [], eofToken, resultErrorParse) => {
  const parsedTokens = []
  const trimmed = textBeforeCursor.replace(/^\s/, '')
  const errorPosition = resultErrorParse ? resultErrorParse.position : null

  let parsedPosition = 0

  if (!tokens || !tokens[0] || tokens[0].token !== 'EOF') {
    parsedTokens.push(eofToken)
  }

  if (tokens && tokens.length) {
    for (const token of tokens) {
      const position = token.position + token.match.length
      if (trimmed.length < position) {
        break
      }
      if (!errorPosition || (errorPosition && errorPosition >= position)) {
        parsedPosition = position
        parsedTokens.push(token)
      }
    }
  }

  const parsedText = trimmed.slice(0, parsedPosition)
  const nonParsedText = trimmed.slice(parsedPosition)

  return { parsedTokens, parsedText, nonParsedText }
}

export default (textBeforeCursor, textAfterCursor, parseResultPattern, parseResultEof) => {
  const oefTokens = extractTokens(parseResultEof)
  const oefToken = oefTokens ? oefTokens[0] : null
  const resultParsedTokens = extractTokens(parseResultPattern)
  const resultErrorParse = extractParseError(parseResultPattern)

  if (oefToken && (resultParsedTokens || resultErrorParse)) {
    const { parsedTokens, parsedText, nonParsedText } = extractBeforeCursor(
      textBeforeCursor,
      resultParsedTokens,
      oefToken,
      resultErrorParse
    )

    const lastTokenType = extractLastTokenProperty(parsedTokens, 'token', 1)
    const lastExpectedTokens = extractLastTokenProperty(parsedTokens, 'expected', 1)
    const prelastTokenType = extractLastTokenProperty(parsedTokens, 'token', 2)
    const prelastExpectedTokens = extractLastTokenProperty(parsedTokens, 'expected', 2)
    const preprelastTokenType = extractLastTokenProperty(parsedTokens, 'token', 3)
    const preprelastExpectedTokens = extractLastTokenProperty(parsedTokens, 'expected', 3)

    return {
      text: {
        beforeCursor: textBeforeCursor,
        afterCursor: textAfterCursor,
        nonParsed: nonParsedText,
        parsed: parsedText
      },
      tokens: {
        type: {
          preprelast: preprelastTokenType,
          prelast: prelastTokenType,
          last: lastTokenType
        },
        expected: {
          preprelast: preprelastExpectedTokens,
          prelast: prelastExpectedTokens,
          last: lastExpectedTokens
        },
        match: {
          preprelast: extractLastTokenProperty(parsedTokens, 'match', 3),
          prelast: extractLastTokenProperty(parsedTokens, 'match', 2),
          last: extractLastTokenProperty(parsedTokens, 'match', 1)
        }
      }
    }
  }

  return null
}
